import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'
import { Link, useParams } from 'react-router-dom'

import { useFilterQuery } from 'helpers/hooks'
import { Icons } from 'helpers/icons'
import BasicLayout from 'layouts/basicLayout/BasicLayout'
import WithoutHeaderSection from 'layouts/WithoutHeaderSection/WithoutHeaderSection'
import { type UserProfile } from 'models'
import { verifyEmail } from 'services/endpoints/auth'
import { useSetUserProfile, useUserProfile } from 'store'

import styles from './VerifyEmail.module.scss'

export const VerifyEmail = () => {
    const { userId, token } = useParams<{
        userId: string
        token: string
    }>()
    const queryParams = useFilterQuery()
    const { t } = useTranslation()
    const [verified, setVerified] = useState<boolean>(false)
    const queryClient = useQueryClient()
    const user = useUserProfile()

    useEffect(() => {
        const expires = parseInt(queryParams.get('expires') ?? '')
        const signature = queryParams.get('signature') ?? ''
        if (userId && token && expires && signature) {
            verifyEmail(userId, token, expires, signature)
                .then(() => {
                    if (user) {
                        const previousQueryData = queryClient.getQueryData(
                            'user-profile'
                        ) as UserProfile

                        queryClient.setQueryData('user-profile', () => {
                            return {
                                ...previousQueryData,
                                is_verified: true
                            }
                        })

                        useSetUserProfile({ ...user, is_verified: true })
                    }

                    setVerified(true)
                })
                .catch(error => {
                    console.error('Error while verifying email.', error)
                    setVerified(false)
                })
        }
    }, [queryParams, token, userId])

    return (
        <BasicLayout
            title={t('emailVerification')}
            customClass={styles.verify_email_layout}
        >
            <WithoutHeaderSection customClass='QWEQWEQWE'>
                <div className={styles.verify_email}>
                    {verified ? (
                        <>
                            <p>{t('emailSuccessfullyVerified')}</p>
                            <Link
                                className={styles.go_home_button}
                                to={{ pathname: '/' }}
                            >
                                <img src={Icons.home} alt={t('home')} />
                                &nbsp; {t('goToHomepage')}
                            </Link>
                        </>
                    ) : verified === undefined ? (
                        <>
                            <p>
                                {t('verifingEmail')}... {t('pleaseWait')}
                            </p>
                        </>
                    ) : (
                        <>
                            <p>{t('error:errorWhileVerifingEmail')}</p>
                            <Link
                                className={styles.go_home_button}
                                to={{ pathname: '/' }}
                            >
                                <img src={Icons.home} alt={t('home')} />
                                &nbsp; {t('goToHomepage')}
                            </Link>
                        </>
                    )}
                </div>
            </WithoutHeaderSection>
        </BasicLayout>
    )
}
